import { createAssist991Template, createAssist991Blurb } from './911-assist';
import {
  createBillingInsuranceTemplate,
  createBillingInsuranceBlurb,
} from './billing-and-insurance';
import {
  createBPOnboardingTemplate,
  createBPOnboardingBlurb,
} from './bp-onboarding';
import { createClinicCallTemplate, createClinicCallBlurb } from './clinic-call';
// import {
//   CallAttemptSmsTemplate,
//   createCallAttemptSmsBlurb,
// } from './call-attempt-sms';
// import {
//   CallAttemptVoicemailTemplate,
//   createCallAttemptVoicemailBlurb,
// } from './call-attempt-voicemail';
// import {
//   CriticalEscalationToClinicTemplate,
//   createCriticalEscalationToClinicBlurb,
// } from './critical-escalation-to-clinic';
import {
  createDeviceIssueTemplate,
  createDeviceIssueBlurb,
} from './device-issue';
import {
  createGlucometerOnboardingTemplate,
  createGlucometerOnboardingBlurb,
} from './glucometer-onboarding';
import {
  createInconsistentReadingsTemplate,
  createInconsistentReadingsBlurb,
} from './inconsistent-readings';
import {
  createInternalNurseEscalationTemplate,
  createInternalNurseEscalationBlurb,
} from './internal-nurse-escalation';
import { createMobileAppTemplate, createMobileAppBlurb } from './mobile-app';
import {
  createNormalReadingsTemplate,
  createNormalReadingsBlurb,
} from './normal-readings';
// import {
//   MaToNurseReportingTemplate,
//   createMaToNurseReportingBlurb,
// } from './nurse-reporting';
// import {
//   PatientUpdateTemplate,
//   createPatientUpdateBlurb,
// } from './patient-update';
// import {
//   PeakFlowMeterOnboardingTemplate,
//   createPeakFlowMeterOnboardingBlurb,
// } from './peak-flow-meter-onboarding';
// import { PharmacyCallTemplate, createPharmacyCallBlurb } from './pharmacy-call';
import {
  createProgramIntroTemplate,
  createProgramIntroBlurb,
} from './program-intro';
// import {
//   ProviderOfficeCallTemplate,
//   createProviderOfficeCallBlurb,
// } from './provider-office-call';
import {
  createPulseOxOnboardingTemplate,
  createPulseOxOnboardingBlurb,
} from './pulse-ox-onboarding';
import {
  createRefillDynamicTemplate,
  createRefillDynamicBlurb,
} from './refill-dynamic';
import {
  createRoutineInteractionTemplate,
  createRoutineInteractionBlurb,
} from './routine-interaction';
import {
  createScaleOnboardingTemplate,
  createScaleOnboardingBlurb,
} from './scale-onboaring';
// import { SDOHTemplate, createSDOHBlurb } from './sdoh';
import {
  createSelfOnboardingTemplate,
  createSelfOnboardingBlurb,
} from './self-onboarding';
import {
  createSleepMatOnboardingTemplate,
  createSleepMatOnboardingBlurb,
} from './sleep-mat-onboarding';
import {
  createSuicideHomicideTemplate,
  createSuicideHomicideBlurb,
} from './suicide-homicide';
import { createTransitionTemplate, createTransitionBlurb } from './transition';

import type { IScriptTemplate, ITemplateProps } from '../types';

export const MAscriptsLibrary = (props: ITemplateProps): IScriptTemplate[] => [
  {
    name: 'Assist 991',
    template: createAssist991Template(props),
    createBlurb: createAssist991Blurb,
  },
  {
    name: 'Billing Insurance',
    template: createBillingInsuranceTemplate(props),
    createBlurb: createBillingInsuranceBlurb,
  },
  {
    name: 'BP Onboarding',
    template: createBPOnboardingTemplate(props),
    createBlurb: createBPOnboardingBlurb,
  },
  // {
  //   name: 'Call Attempt Sms',
  //   template: CallAttemptSmsTemplate,
  //   createBlurb: createCallAttemptSmsBlurb,
  // },
  // {
  //   name: 'Call Attempt Voicemail',
  //   template: CallAttemptVoicemailTemplate,
  //   createBlurb: createCallAttemptVoicemailBlurb,
  // },
  {
    name: 'Clinic Call',
    template: createClinicCallTemplate(props),
    createBlurb: createClinicCallBlurb,
  },
  // {
  //   name: 'Critical Escalation To Clinic',
  //   template: CriticalEscalationToClinicTemplate,
  //   createBlurb: createCriticalEscalationToClinicBlurb,
  // },
  {
    name: 'Device Issue',
    template: createDeviceIssueTemplate(props),
    createBlurb: createDeviceIssueBlurb,
  },
  {
    name: 'Glucometer Onboarding',
    template: createGlucometerOnboardingTemplate(props),
    createBlurb: createGlucometerOnboardingBlurb,
  },
  {
    name: 'Inconsistent Readings',
    template: createInconsistentReadingsTemplate(props),
    createBlurb: createInconsistentReadingsBlurb,
  },
  {
    name: 'Internal Nurse Escalation',
    template: createInternalNurseEscalationTemplate(props),
    createBlurb: createInternalNurseEscalationBlurb,
  },
  {
    name: 'Mobile App',
    template: createMobileAppTemplate(props),
    createBlurb: createMobileAppBlurb,
  },
  {
    name: 'Normal Readings',
    template: createNormalReadingsTemplate(props),
    createBlurb: createNormalReadingsBlurb,
  },
  // {
  //   name: 'Ma To Nurse Reporting',
  //   template: MaToNurseReportingTemplate,
  //   createBlurb: createMaToNurseReportingBlurb,
  // },
  // {
  //   name: 'Patient Update',
  //   template: PatientUpdateTemplate,
  //   createBlurb: createPatientUpdateBlurb,
  // },
  // {
  //   name: 'Peak FlowMeter Onboarding',
  //   template: PeakFlowMeterOnboardingTemplate,
  //   createBlurb: createPeakFlowMeterOnboardingBlurb,
  // },
  // {
  //   name: 'Pharmacy Call',
  //   template: PharmacyCallTemplate,
  //   createBlurb: createPharmacyCallBlurb,
  // },
  {
    name: 'Program Intro',
    template: createProgramIntroTemplate(props),
    createBlurb: createProgramIntroBlurb,
  },
  // {
  //   name: 'Provider Office Call',
  //   template: ProviderOfficeCallTemplate,
  //   createBlurb: createProviderOfficeCallBlurb,
  // },
  {
    name: 'Pulse Ox Onboarding',
    template: createPulseOxOnboardingTemplate(props),
    createBlurb: createPulseOxOnboardingBlurb,
  },
  {
    name: 'Refill Dynamic',
    template: createRefillDynamicTemplate(props),
    createBlurb: createRefillDynamicBlurb,
  },
  {
    name: 'Routine Interaction',
    template: createRoutineInteractionTemplate(props),
    createBlurb: createRoutineInteractionBlurb,
  },
  {
    name: 'Scale Onboarding',
    template: createScaleOnboardingTemplate(props),
    createBlurb: createScaleOnboardingBlurb,
  },
  // {
  //   name: 'SDOH',
  //   template: SDOHTemplate,
  //   createBlurb: createSDOHBlurb,
  // },
  {
    name: 'Self Onboarding',
    template: createSelfOnboardingTemplate(props),
    createBlurb: createSelfOnboardingBlurb,
  },
  {
    name: 'Sleep Mat Onboarding',
    template: createSleepMatOnboardingTemplate(props),
    createBlurb: createSleepMatOnboardingBlurb,
  },
  {
    name: 'Suicide Homicide',
    template: createSuicideHomicideTemplate(props),
    createBlurb: createSuicideHomicideBlurb,
  },
  {
    name: 'Transition',
    template: createTransitionTemplate(props),
    createBlurb: createTransitionBlurb,
  },
];
